angular.module("vgresiduos").controller("editVehicleCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton(
				$rootScope,
				`organizacao/fornecedores/${$stateParams.supplierCode}/veiculo/${$stateParams.vehicleId}`,
				[{ key: "supplierId", value: $stateParams.supplierId }]
			);
		};
	}
]);
